import { SET_USER_INFO, CLEAR_USER_INFO, UserInfo, SetUserInfoAction, ClearUserInfoAction } from '../types/userTypes';

/**
 * Action to set user information in Redux store
 */
export const setUserInfo = (userInfo: UserInfo): SetUserInfoAction => ({
  type: SET_USER_INFO,
  payload: userInfo,
});

/**
 * Action to clear user information from Redux store
 */
export const clearUserInfo = (): ClearUserInfoAction => ({
  type: CLEAR_USER_INFO,
});
